import { useMemo } from 'react';

import { joinCn } from '../util';
import twStyle from './style';
import type { VGridProps } from './type';

const genColsOrRowsValue = (
  colsOrRows?: number,
  colsOrRowsWidth?: string[],
) => {
  let colsValue = '';

  if (colsOrRows != null && colsOrRows > 0) {
    let remained = colsOrRows;
    let repeated = 0;

    if (colsOrRowsWidth?.length) {
      for (let i = 0; i < colsOrRows; i++) {
        const colWidth = colsOrRowsWidth[i];

        remained--;

        if (colWidth) {
          repeated && (colsValue += `repeat(${repeated},minmax(0,1fr)) `);
          repeated = 0;
          colsValue += `${colWidth} `;
        } else {
          repeated++;
        }
      }

      if (repeated) {
        colsValue += `repeat(${repeated},minmax(0,1fr)) `;
      }
    } else {
      colsValue = `repeat(${remained},minmax(0,1fr))`;
    }
  }

  return colsValue;
};

const VGrid = ({
  children,
  className,
  cols,
  colsWidth,
  gap,
  rows,
  rowsHeight,
  style,
  ref,
  ...rest
}: React.PropsWithChildren<VGridProps> &
  React.ComponentPropsWithRef<'div'>) => {
  const _style = twStyle({});
  const gridStyle = useMemo(() => {
    const gapValue = gap != null ? `${+gap * 16}px` : undefined;
    const colsValue = genColsOrRowsValue(cols, colsWidth);
    const rowsValue = genColsOrRowsValue(rows, rowsHeight);

    return {
      ...style,
      '--gap': gapValue,
      '--columns': colsValue,
      '--rows': rowsValue,
    };
  }, [cols, colsWidth, gap, rows, rowsHeight, style]);

  return (
    <div
      ref={ref}
      className={joinCn(_style.container, className)}
      style={gridStyle}
      {...rest}
    >
      {children}
    </div>
  );
};

export default VGrid;
